const siteUrl = import.meta.env.VITE_SITE_URL || 'https://kakobuyfinds.lol';
const siteName = 'Kakobuy Finds';
const siteDescription = 'Discover the best Kakobuy Spreadsheet collections, trending products, verified finds, comparison guides, and shopping resources. Updated product lists, community recommended finds, and detailed guides for smarter shopping.';

export function getHomepageSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteName,
    url: siteUrl,
    description: siteDescription,
    inLanguage: 'en',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${siteUrl}/?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  };
}

export function getOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteName,
    url: siteUrl,
    description: siteDescription,
    sameAs: [
      'https://kaspreadsheet.com',
    ],
  };
}

export function getArticleSchema(params: {
  title: string;
  description: string;
  datePublished: string;
  dateModified: string;
  authorName?: string;
  imageUrl?: string;
  slug: string;
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: params.title,
    description: params.description,
    datePublished: params.datePublished,
    dateModified: params.dateModified,
    author: {
      '@type': 'Organization',
      name: params.authorName || siteName,
      url: siteUrl,
    },
    publisher: {
      '@type': 'Organization',
      name: siteName,
      url: siteUrl,
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `${siteUrl}/articles/${params.slug}`,
    },
    ...(params.imageUrl ? { image: params.imageUrl } : {}),
  };
}

export function getBreadcrumbSchema(items: { name: string; url: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url.startsWith('http') ? item.url : `${siteUrl}${item.url}`,
    })),
  };
}